<template>
  <div id="section-profile" class="section-full">
    <div id="section-profile-inner">
      <div>
        <span class="has-text-weight-bold">{{ profile.realname }}</span>
        <span v-if="professional_number.number">
          <br />
          Número de colegiado: {{ professional_number.number }}<br
        /></span>

        {{ profile.mail }} <br />
      </div>

      <div v-if="profile_doctor_login.resident">
        Residente. {{ profile_doctor_login.resident_year }} Años
      </div>
    </div>
    <div class="register-forms-container">
      <div class="section">
        <h1 class="subtitle">Información personal</h1>
        <b-field v-if="profile_doctor_login.title">
          <b-radio-button
            type="is-primary"
            native-value="Dra"
            v-model="doctor_title"
          >
            <span>Dra.</span>
          </b-radio-button>

          <b-radio-button
            type="is-primary"
            native-value="Dr"
            v-model="doctor_title"
          >
            <span>Dr.</span>
          </b-radio-button>
        </b-field>
        <b-field>
          <b-icon
            class="onlyline-icon"
            pack="mdi"
            icon="account"
            size="is-small"
          >
          </b-icon>
          <b-input
            type="text"
            class="onlyline"
            placeholder="Nombre"
            expanded
            v-model="user_name"
            required
            ref="nameField"
          >
          </b-input>
        </b-field>

        <b-field>
          <b-input
            type="text"
            class="onlyline apellido"
            placeholder="Apellido"
            expanded
            v-model="user_surname"
            required
            ref="surnameField"
          >
          </b-input>
        </b-field>

        <b-field>
          <b-input
            type="text"
            class="onlyline apellido"
            placeholder="Segundo Apellido"
            expanded
            v-model="user_surname2"
            ref="surname2Field"
          >
          </b-input>
        </b-field>
      </div>

      <div class="section" id="validate-number" v-if="isDoctorNotValidated">
        <ValidateNumber
          :user_name="user_name"
          :user_surname="user_surname"
          v-model="professional_number"
        >
        </ValidateNumber>
      </div>

      <div class="section section_photo">
        <h1 class="subtitle">Imagen de perfil</h1>
       <img :src="user_photo" alt="Imagen de perfil" @click="editPhotoModal = true">
       <EditPhoto
        @close-modal="editPhotoModal = false"
        v-if="editPhotoModal"
        :user_photo="user_photo"
        />
      </div>

      <div
        class="section"
        id="residente"
        v-if="Object.keys(profile_doctor_login).includes('resident_year')"
      >
        <h1 class="subtitle">Residente</h1>
        <div class="field">
          <b-checkbox v-model="doctor_resident"
            >Soy médico residente</b-checkbox
          >
        </div>
        <div class="anios-container" v-if="doctor_resident">
          <b-field label="Año de residencia" horizontal>
            <b-input
              type="number"
              min="0"
              max="9"
              value="1"
              style="width:3em;"
              v-model="doctor_resident_year"
            ></b-input>
          </b-field>
        </div>
      </div>
      <div class="section">
        <h1 class="subtitle">Centro y especialidad</h1>
        <b-field :message="citymsg" :type="citytype">
          <b-icon
            class="onlyline-icon"
            pack="mdi"
            icon="map-marker"
            size="is-small"
          >
          </b-icon>
          <b-autocomplete
            expanded
            class="onlyline"
            rounded
            v-model="cityname"
            :data="filteredDataArray"
            placeholder="Localidad"
            :open-on-focus="openOnFocus"
            icon="magnify"
            field="name"
            :keep-first="keepfirst"
            @select="citySelected"
            ref="cityname"
          >
            <template slot="empty">No hay resultados</template>
          </b-autocomplete>
        </b-field>
        <div v-if="isLoading">
          Cargando datos...
          <div style="text-align:center">
            <b-loading
              :is-full-page="true"
              v-model="isLoading"
              :can-cancel="true"
            ></b-loading>
          </div>
        </div>
        <template v-if="dataLoaded">
          <template>
            <b-field :message="jobcentermsg" :type="jobcentertype">
              <b-icon
                class="onlyline-icon"
                pack="mdi"
                icon="hospital-building"
                size="is-small"
              >
              </b-icon>
              <b-autocomplete
                expanded
                class="onlyline"
                rounded
                v-model="jobcentername"
                :data="filteredDataArrayJobcenters"
                placeholder="Centro de Trabajo"
                :open-on-focus="openOnFocus"
                icon="magnify"
                field="name"
                :keep-first="keepfirst"
                @select="jobcenterSelected"
                ref="jobcentername"
              >
                <template slot="footer">
                  <a @click="showCustomCenter">
                    <span> Añadir centro </span>
                  </a>
                </template>
                <template slot="empty">
                  No hemos encontrado tu centro de trabajo.
                </template>
              </b-autocomplete>
            </b-field>

            <b-field
              :message="specialitymsg"
              :type="specialitytype"
              v-if="profile_doctor_login.specialty_main"
            >
              <b-icon
                class="onlyline-icon"
                pack="mdi"
                icon="medical-bag"
                size="is-small"
              >
              </b-icon>
              <b-autocomplete
                expanded
                class="onlyline"
                rounded
                v-model="specialityname"
                :data="filteredDataArraySpecialities"
                placeholder="Especialidad"
                :open-on-focus="openOnFocus"
                icon="magnify"
                field="name"
                :keep-first="keepfirst"
                @select="specialitySelected"
                ref="specialityname"
              >
                <template slot="empty">Sin resultados.</template>
              </b-autocomplete>
            </b-field>
          </template>
        </template>
        <!--   Error stack:
        {{ error_stack }}
        Error stack2:
        {{ error_stack2 }}
        Error1:
        {{ error_1 }}-->
      </div>
    </div>
    <div class="register-button-container">
      <a
        class="register-button button is-fullwidth is-primary"
        @click="sendData"
        v-if="dataLoaded"
      >
        Actualizar datos
      </a>
    </div>
  </div>
</template>

<script>
import { ToolsMixin } from '@/components/mixins/ToolsMixin'
import ValidateNumber from '@/components/UI/ValidateNumber.vue'
import EditPhoto from '@/components/EditPhoto.vue'
import { cities } from '@/assets/cities.js'
export default {
  name: 'UserProfile',
  mixins: [ToolsMixin],

  components: { ValidateNumber, EditPhoto },
  props: {},
  data: () => ({
    isLoading: false,
    cities: cities,
    openOnFocus: true,
    selectedcity: null,
    cityname: '',
    selectedJobcenter: null,
    jobcentername: '',
    jobcenter_other: null,
    selectedSpeciality: null,
    specialityname: '',
    keepfirst: true,
    citymsg: '',
    citytype: '',
    specialitymsg: '',
    specialitytype: '',
    jobcentermsg: '',
    jobcentertype: '',
    doctor_title: 'Dra',
    doctor_resident: false,
    doctor_resident_year: '0',
    professional_number: { number: '', isValid: true },
    user_name: '',
    user_surname: '',
    user_surname2: '',
    responseUpdatedProfileServer: null,
    user_photo: '',
    editPhotoModal: false,
    /*error_1: '',
    error_stack: '',
    error_stack2: ''*/
  }),
  computed: {
    isApp() {
      return this.$store.state.isApp
    },
    profile() {
      return this.$store.state.auth.profile
    },
    profileEmpty() {
      return this._.isEmpty(this.$store.state.auth.profile)
    },
    especialidad() {
      if (this.profile_doctor_login) {
        return this.profile_doctor_login.specialty_main.name
      } else return ''
    },
    isDoctorNotValidated() {
      return this.profile.statuses.doctor.name == 'STATUS_FAIL_NOT_VALID'
        ? true
        : false
    },
    currentJobCenter() {
      return this.profile_doctor_login.jobcenter_other
        ? { name: this.profile_doctor_login.jobcenter_other, uuid: '', id: -1 }
        : this.profile_doctor_login.jobcenter
    },
    profile_doctor_login() {
      return this.$store.state.auth.profile.profile
    },
    getSpecialitiesArray() {
      return this.$store.state.register.specialities
    },
    getJobcentersArray() {
      if (this.jobcenter_other === null)
        return this.$store.state.register.jobcenters
      else
        return this.$store.state.register.jobcenters.concat(
          this.jobcenter_other
        )
    },
    filteredDataArray() {
      return this.cities.filter(option => {
        return (
          option.name
            .toString()
            .toLowerCase()
            .indexOf(this.cityname.toLowerCase()) >= 0
        )
      })
    },
    dataLoaded() {
      if (this.profile.doctor_specialty_main) {
        return (
          this.$store.state.register.jobcenters.length > 0 &&
          this.$store.state.register.specialities.length > 0
        )
      } else {
        return this.$store.state.register.jobcenters.length > 0
      }
    },
    filteredDataArraySpecialities() {
      return this.getSpecialitiesArray.filter(option => {
        return (
          option.name
            .toString()
            .toLowerCase()
            .indexOf(this.specialityname.toLowerCase()) >= 0
        )
      })
    },
    filteredDataArrayJobcenters() {
      return this.getJobcentersArray.filter(option => {
        return (
          option.name
            .toString()
            .toLowerCase()
            .indexOf(this.jobcentername.toLowerCase()) >= 0
        )
      })
    }
  },
  watch: {
    selectedcity: function() {
      console.log(this.selectedcity)
      if (this.selectedcity !== null && 'id' in this.selectedcity) {
        //this.selectedJobcenter = null
        this.isLoading = true
        /* ojo aquí tenemos que diferenciar dos casos
        si el usuario a mano está cambiando la ciudad seleccionada hay que borrar el centro médico
        si el watcher se activa porque acabmos de setear la opción por primera vez, entonces no hay que hacerlo y hay que dejar el centro medico por defecto
        */
        this.$store
          .dispatch('register/getJobcenters', {
            administrative_area: this.selectedcity.id
          })
          .then(() => {
            if (
              this.selectedJobcenter === null ||
              this.currentJobCenter.uuid != this.selectedJobcenter.uuid
            ) {
              //first time, we let the default jobcenter
              if (this.currentJobCenter.id == -1) {
                // this mean jobcenter is custom job center entered by user
                this.jobcenter_other = this.currentJobCenter
                console.log('loading custom job center')
                console.log(this.$refs.jobcentername)
                this.jobcenterSelected(this.currentJobCenter)
              } else {
                this.jobcenterSelected(this.currentJobCenter)
              }
              /*
              this.selectedJobcenter = this.getCenterFromName(
                this.currentJobCenter.uuid
              )
              this.jobcenterSelected(
                this.getCenterFromName(this.currentJobCenter.uuid)
              )
              this.jobcentername = this.currentJobCenter.name*/
            } else {
              this.jobcenterSelected(null)
              //this.selectedJobcenter = null
              //this.jobcentername = ''
              //this.validateJobcenter()
            }
            this.isLoading = false
          })
      }
    },
    editPhotoModal: function () {

      if (this.editPhotoModal === false) {
       this.getUserPhoto();
      } else {
       return false
     }
   }
  },
  methods: {
    sendData() {
      if (this.isFormValid()) {
        console.log('isFormValid')
        this.isLoading = true
        let doctor_jobcenter_other = undefined
        let doctor_jobcenter = undefined
        if (this.selectedJobcenter.id === -1)
          // in true selected jobcenter is a job center added manually that should go in the doctor_jobcenter_other field
          doctor_jobcenter_other = this.jobcentername
        else doctor_jobcenter = this.selectedJobcenter.id
        let profObj = {
          doctor_title: this.doctor_title,
          doctor_resident: this.doctor_resident,
          doctor_resident_year: this.doctor_resident_year,
          user_name: this.user_name,
          user_surname: this.user_surname,
          user_surname2: this.user_surname2,
          professional_number: this.professional_number.number,
          doctor_jobcenter: doctor_jobcenter,
          doctor_jobcenter_other: doctor_jobcenter_other,
          administrative_area: this.selectedcity.id
        }
        console.log(this.selectedSpeciality)
        if (this.selectedSpeciality !== null) {
          profObj = Object.assign(
            { doctor_specialty_main: this.selectedSpeciality.tid },
            profObj
          )
        }
        console.log('EditUser/updateProfile --> profObj')
        console.log(profObj)
        //this.$store.commit('register/cleanCredentials')
        this.showPageLoader = true

        this.$store
          .dispatch('auth/updateProfile', profObj)
          .then(r => {
            if (!this.isApp)
              this.$store.commit('auth/setUpdatedUserinfo', r.data.data)
            this.$buefy.toast.open({
              duration: 8000,
              message: 'Ya tienes tus datos de perfil actualizados',
              type: 'is-success'
            })
            //  query: this.$router.query
            this.$router.push({ name: 'edit' }).catch(error => {
              console.info(error.message)
            })
            if (this.isApp) {
              window.location.href = 'tokmed://edit/ok'
              this.responseUpdatedProfileServer = r.data.data
            }
          })
          .finally(() => {
            this.isLoading = false
          })
          .catch(error => {
            console.log(error)
            /* this.error_stack = error.stack
            var err = new Error()
            this.error_1 = error
            this.error_stack2 = err.stack*/
            this.$buefy.toast.open({
              duration: 8000,
              message: 'Error actualizando datos' + error,
              type: 'is-error'
            })
          })
      }
    },
    showCustomCenter() {
      this.$buefy.dialog.prompt({
        message: `Nombre de tu centro de trabajo`,
        inputAttrs: {
          placeholder: 'Hospital, centro de salud ...',
          maxlength: 20,
          value: this.name
        },
        confirmText: 'Añadir',
        onConfirm: value => {
          this.jobcenter_other = { id: -1, name: value, uuid: -1 }
          this.$refs.jobcentername.setSelected(this.jobcenter_other)
        }
      })
    },
    citySelected(option) {
      this.selectedcity = option
      if (option === null) this.cityname = ''
      else this.cityname = option.name
      this.validateCityname()
    },
    jobcenterSelected(option) {
      console.log('jobcenterSelected')
      console.log(option)
      //if (option.id === -1) this.jobcenter_other = null
      this.selectedJobcenter = option
      if (option === null) this.jobcentername = ''
      else this.jobcentername = option.name
      this.validateJobcenter()
    },
    specialitySelected(option) {
      this.selectedSpeciality = option
      if (option === null) this.specialityname = ''
      else this.specialityname = option.name
      this.validateSpeciality()
    },
    isFormValid() {
      if (this.profile.doctor_specialty_main) {
        return (
          this.validateCityname() &&
          this.validateSpeciality() &&
          this.validateJobcenter()
        )
      } else {
        return this.validateCityname() && this.validateJobcenter()
      }
    },
    validateJobcenter() {
      if (this.jobcentername.length > 3) {
        this.jobcentermsg = ''
        this.jobcentertype = 'is-success'
        return true
      } else {
        this.jobcentermsg =
          'Selecciona un centro de trabajo. Si no aparece el tuyo escríbelo. '
        this.jobcentertype = 'is-danger'
        return false
      }
    },
    validateCityname() {
      var cityname2 = this.cityname.toLowerCase()
      var vv = this.cities.filter(element => {
        return (
          element.name
            .toString()
            .toLowerCase()
            .indexOf(cityname2) >= 0
        )
      })
      if (vv.length > 0) {
        this.citymsg = ''
        this.citytype = 'is-success'
        return true
      } else {
        this.citymsg = 'Parece que no es un nombre de provincia apropiado'
        this.citytype = 'is-danger'
        return false
      }
    },
    validateSpeciality() {
      var specialityname2 = this.specialityname.toLowerCase()
      var vv = this.getSpecialitiesArray.filter(element => {
        return (
          element.name
            .toString()
            .toLowerCase()
            .indexOf(specialityname2) >= 0
        )
      })
      if (vv.length > 0) {
        this.specialitymsg = ''
        this.specialitytype = 'is-success'
        return true
      } else {
        this.specialitymsg = 'Selecciona una especialidad de la lista. '
        this.specialitytype = 'is-danger'
        return false
      }
    },
    getCityFromCode(citycode) {
      const results = this.cities.filter(city => {
        return city.id === citycode
      })
      if (results.length > 0) return results[0]
      else return { id: '', name: '' }
    },
    getCenterFromName(jobCenter) {
      const results = this.filteredDataArrayJobcenters.filter(city => {
        return city.uuid === jobCenter
      })
      if (results.length > 0) return results[0]
      else return { id: '', name: '' }
    },
    getSpecialityFromName(spe_code) {
      const results = this.filteredDataArraySpecialities.filter(spe => {
        return spe.id === spe_code
      })
      if (results.length > 0) return results[0]
      else return { id: '', name: '' }
    },
    returnDataObjectMethod() {
      return {
        data: this.responseUpdatedProfileServer
      }
    },
    getUserPhoto() {
      this.$store
        .dispatch('auth/getPhoto')
        .then((response) => {
          console.log('Photo loaded')
          console.log(response);

          if (response.data.photo['fid'] === null || typeof response.data.photo[0] !== 'undefined') {
            if (response.data.photo[0].fid === null) {
              this.user_photo = response.data.photo[0].presets;
            }
          }
          else {
            this.user_photo = response.data.photo.presets;
          }
      })
    },
  },
  /*
  0:[
  Object
  id:7634
n ame:"C.S. Abejuela"
]
  */
  mounted() {
    window.getResponseDataObject = this.returnDataObjectMethod
    //if (this._.isEmpty(this.$store.state.auth.profile)) {
    //this.$store.dispatch('auth/getProfile').then(() => {
    //  this.isLoading = false
    //console.log(this.$store.state.auth.profile)
    this.cityname = this.getCityFromCode(
      this.profile.profile.adressfield.administrative_area
    ).name
    this.selectedcity = this.getCityFromCode(
      this.profile.profile.adressfield.administrative_area
    )
    this.citySelected(this.selectedcity)
    // job center lo hace dentro del watch de este bloque
    if (this.profile.profile.specialty_main) {
      this.$store.dispatch('register/getSpecialities', {
        country: this.profile.profile.adressfield.country
      }).then(() => {
        // this.selectedSpeciality = this.getSpecialityFromName()
        // this.specialitySelected(this.selectedSpeciality)
        // this.specialityname = this.selectedSpeciality.name
        this.specialityname = this.profile.profile.specialty_main.name
      })
    }

    this.user_name = this.profile.name
    this.user_surname = this.profile.surname
    this.user_surname2 = this.profile.surname2
    this.doctor_title = this.profile.profile.title
    this.professional_number.number = this.profile.profile.professional_number
    this.doctor_resident = this.profile.profile.resident
    this.doctor_resident_year = this.profile.profile.resident_year
    //this.user_photo = this.profile.photo.presets

    //})
    this.getUserPhoto();
  }
}
</script>

<style lang="less" scoped>
#section-profile-inner {
  margin-top: 44px;
  text-align: center;
  h1 {
    margin-top: 1em;
    font-size: 1.2em;
    font-weight: bold;
  }
}
.section_photo {
  padding-bottom: 1.5rem;
  padding-top: 1.5rem;

  img {
   cursor: pointer;
  }
}
</style>
